import { Elastic, Sine, TimelineLite } from "gsap";
import * as HLF from "html-living-framework";
import { AppProgress } from "../Data/AppProgress";
import * as Constants from "../Data/Constants";
import * as Topics from "../Data/Topics";

export class ProgressBar extends PIXI.Container {
    private static readonly TRACK_WIDTH: number = 325;

    private _bg: PIXI.Sprite;
    private _balloon: PIXI.Sprite;
    private _flag: PIXI.Sprite;
    private _ticket: PIXI.Sprite;
    private _checkmark: PIXI.Sprite;

    private _progress: number;

    private _checkmarkTween: TimelineLite | undefined;
    private _subscriptions: any[];

    constructor() {
        super();
        this._progress = 0;

        this._bg = HLF.PixiUtils.makeSprite("progress-bg", Constants.SPRITESHEET_UI);
        this.addChild(this._bg);

        this._ticket = HLF.PixiUtils.makeSprite("progress-ticket", Constants.SPRITESHEET_UI);
        this._ticket.anchor.set(0.5, 0.425);
        this._ticket.position.set(0, 0);
        this.addChild(this._ticket);

        this._checkmark = HLF.PixiUtils.makeSprite("checkmark", Constants.SPRITESHEET_UI);
        this._checkmark.position.set(-5, 0);
        this._checkmark.scale.set(0.7);
        this.addChild(this._checkmark);
        if (AppProgress.checkpointReached === false) {
            this._checkmark.visible = false;
        }

        this._flag = HLF.PixiUtils.makeSprite("progress-flag", Constants.SPRITESHEET_UI);
        this._flag.position.set(ProgressBar.TRACK_WIDTH * 0.5, 0);
        this.addChild(this._flag);

        this._balloon = HLF.PixiUtils.makeSprite(
            "progress-balloon-0" + AppProgress.activeBalloon,
            Constants.SPRITESHEET_UI,
        );
        this._balloon.position.set(ProgressBar.TRACK_WIDTH * -0.5, 0);
        this.addChild(this._balloon);

        this._subscriptions = new Array<any>();
        this._subscriptions.push(PubSub.subscribe(
            Topics.UPDATE_PROGRESS,
            this.onUpdateProgressMessageReceived.bind(this),
        ));
        this._subscriptions.push(PubSub.subscribe(
            Topics.TICKET_COLLECTED,
            this.onTicketCollected.bind(this),
        ));
    }

    public destroy(pOptions?: boolean | PIXI.DestroyOptions): void {
        super.destroy(pOptions);
        for (let i = 0; i < this._subscriptions.length; ++i) {
            PubSub.unsubscribe(this._subscriptions[i]);
        }
        if (this._checkmarkTween !== undefined) { this._checkmarkTween.kill(); }
    }

    public setProgress(pProgress: number, pInstantly: boolean = false): void {
        this._progress = HLF.MathUtils.clamp(pProgress, 0, 1);
        this._balloon.x = ProgressBar.TRACK_WIDTH * (-0.5 + this._progress);
    }

    private onUpdateProgressMessageReceived(pTopic: string, pValue: number): void {
        this.setProgress(pValue);
    }

    private onTicketCollected(): void {
        if (this._checkmarkTween !== undefined) { this._checkmarkTween.kill(); }

        this._checkmark.visible = true;
        this._checkmark.alpha = 0;
        this._checkmark.scale.set(1.5);

        this._checkmarkTween = new TimelineLite();
        this._checkmarkTween.to(this._checkmark.scale, 1.0, {
            x: 0.7,
            y: 0.7,
            ease: Elastic.easeOut,
        }, 0);
        this._checkmarkTween.to(this._checkmark, 0.35, {
            alpha: 1,
            ease: Sine.easeInOut,
        }, 0);
    }
}
